// When to nudge a guest to sign in. The pattern comes from games like Clash
// Royale: don't ask at launch, ask right after the player has done something
// worth keeping, frame it as saving what they have, and never nag.
//
// The rules live here as a pure function so they are easy to test and to tune.

/** After a dismissal, stay quiet for this long. */
export const SAVE_PROMPT_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000

export interface SavePromptInput {
  /** Someone is signed in (or we are still finding out). Never prompt then. */
  signedIn: boolean
  initializing: boolean
  /** The moment worth keeping: a win. */
  won: boolean
  /** When the player last chose "Not now", or null if never. */
  lastDismissedAt: number | null
  now: number
}

export const shouldShowSavePrompt = ({ signedIn, initializing, won, lastDismissedAt, now }: SavePromptInput): boolean => {
  if (initializing || signedIn || !won) return false
  if (lastDismissedAt === null) return true
  // A clock set back must not silence the prompt forever.
  if (lastDismissedAt > now) return true
  return now - lastDismissedAt >= SAVE_PROMPT_COOLDOWN_MS
}
